import { appendIf } from '@btime/helpers'
import { assoc, compose, map, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'

import { placesClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { cleanFieldValuesRequest, validateFieldValues } from '../../../../utils/helpers/fields'
import { getPlaceLevelIdToSave } from '../../../../utils/helpers/place'

const MUTATION = gql`
  mutation UpsertPlaces($inputs: [PlaceInput]) {
    upsertPlaces(inputs: $inputs) {
      id
    }
  }
`

const cleanRequest = map(
  compose(
    pick(['id', 'name', 'type', 'placeLevelId', 'fieldValues']), //
    item => assoc('placeLevelId', getPlaceLevelIdToSave(item), item),
    item => assoc('fieldValues', cleanFieldValuesRequest(item.fieldValues || []), item)
  )
)

const validate = (form, setErrors) => {
  const errors = form.reduce((errors, item, index) => {
    const newErrors = [
      ...errors,
      ...appendIf(!item.name, { path: [index, 'name'], message: 'Campo obrigatório' }),
      ...appendIf(!getPlaceLevelIdToSave(item), { path: [index, 'name'], message: 'Selecione pelo menos um nivel' }),
      ...validateFieldValues(form, [index, 'fieldValues'])
    ]
    return newErrors
  }, [])

  setErrors(errors)
  return errors.length === 0
}

export const useSavePlaces = () => {
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Places'], client: placesClient })

  const handleRequest = (form, actions) => {
    const inputs = cleanRequest(form)
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { inputs } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
